import { render } from "./MenuButtonPass.vue?vue&type=template&id=5e2a9f3a&scoped=true"
import script from "./MenuButtonPass.vue?vue&type=script&lang=js"
export * from "./MenuButtonPass.vue?vue&type=script&lang=js"

import "./MenuButtonPass.vue?vue&type=style&index=0&id=5e2a9f3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2a9f3a"]])

export default __exports__